const SORTABLE = {
  id: true,
  healthStatus: true,
  batteryPct: true,
  lastBarcodeSeenAt: true,
  unheardRideCount: true,
  batteryReplacedAt: true
}

const PAGE_SIZES = [10, 25, 50]
const DEFAULT_SORT = 'lastBarcodeSeenAt'
const DEFAULT_ROWS = 25

function defaultPagination () {
  return {
    sortBy: DEFAULT_SORT,
    descending: true,
    page: 1,
    rowsPerPage: DEFAULT_ROWS
  }
}

function wholeNumber (value, fallback) {
  const number = Number(value)
  if (!number || number < 1 || Math.floor(number) !== number) return fallback
  return number
}

function paginationFromQuery (query) {
  const source = query || {}
  const pagination = defaultPagination()

  if (source.sortBy && SORTABLE[source.sortBy]) pagination.sortBy = String(source.sortBy)
  if (source.descending === 'false' || source.descending === false) pagination.descending = false
  if (source.descending === 'true' || source.descending === true) pagination.descending = true
  if (source.page) pagination.page = wholeNumber(source.page, 1)
  if (source.rowsPerPage) {
    const rows = wholeNumber(source.rowsPerPage, DEFAULT_ROWS)
    pagination.rowsPerPage = PAGE_SIZES.indexOf(rows) === -1 ? DEFAULT_ROWS : rows
  }

  return pagination
}

function searchKeyFromQuery (query) {
  const source = query || {}
  if (source.searchKey === undefined || source.searchKey === null) return ''
  return String(source.searchKey)
}

function beaconListLocation (identifierKey) {
  const key = identifierKey ? String(identifierKey).trim() : ''
  return {
    name: 'passengers-beacons',
    query: key ? { searchKey: key } : {}
  }
}

function listQueryParams (searchKey, pagination) {
  const page = pagination || defaultPagination()
  const key = searchKey ? String(searchKey).trim() : ''
  return {
    searchKey: key || null,
    sortBy: page.sortBy || DEFAULT_SORT,
    descending: page.descending === true,
    page: page.page || 1,
    rowsPerPage: page.rowsPerPage || DEFAULT_ROWS
  }
}

module.exports = {
  defaultPagination: defaultPagination,
  paginationFromQuery: paginationFromQuery,
  searchKeyFromQuery: searchKeyFromQuery,
  beaconListLocation: beaconListLocation,
  listQueryParams: listQueryParams
}
